import { render, staticRenderFns } from "./TranslationTabList.vue?vue&type=template&id=691df120"
import script from "./TranslationTabList.vue?vue&type=script&lang=js"
export * from "./TranslationTabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports